<template>
    <span
        v-if="cny === 'TWD'"
        :data-number="v"
        :class="{
            money: true,
            negative: v < 0,
            positive: v > 0,
            zero: v == 0,
            foreignCny: cny !== 'TWD',
        }
    ">
        <span>{{ formatedValue.integer }}</span>
        <span v-if="formatedValue.decimal" class="decimal">.{{ formatedValue.decimal }}</span>
    </span>
    <span v-else>
        <el-tooltip class="item" effect="dark" content="Top Center 提示文字" placement="top">
            <template slot="content">
                <div style="font-size: 10pt;">約當台幣： {{ foreignToTwdAmt }} 元</div>
                <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px; font-weight: normal;">
                    <span>匯率：</span>
                    <span v-if="this.cnyRat !== 0">{{ this.cnyRat }}</span>
                    <span v-if="this.cnyRat === 0">{{ this.getCnyRat(this.cny) }}</span>
                    <span v-if="this.cnyRat === 0"> (即時)</span>
                </div>
            </template>
            <span
                :data-number="v"
                :class="{
                    money: true,
                    negative: v < 0,
                    positive: v > 0,
                    zero: v == 0,
                    foreignCny: cny !== 'TWD',
                }
            ">
                <span>{{ formatedValue.integer }}</span>
                <span v-if="formatedValue.decimal" class="decimal">.{{ formatedValue.decimal }}</span>
            </span>
    </el-tooltip>
    </span>
</template>
<script>
export default {
    name: 'Money',
    props: {
        v: {
            type: [Number, String],
            default: 0,
        },
        zero: {
            type: String,
        },
        showPositivePlus: {
            type: Boolean,
            default: false,
        },
        round: {
            type: Boolean,
            default: false,
        },
        abs: {
            type: Boolean,
            default: false,
        },
        cny: {
            type: String,
            default: 'TWD',
        },
        cnyRat: {
            type: Number,
            default: 0,
        },
        precision: {
            type: Number,
            default: null,
        },
    },
    methods: {
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        formatNumberWithSpans(numStr) {
            // 檢查是否包含小數點
            if (numStr.includes('.')) {
                // 使用 split 方法將字串分割成整數和小數部分 [1, 4]
                const parts = numStr.split('.');
                const integerPart = parts[0];
                const decimalPart = parts[1];

                return {
                    integer: integerPart,
                    decimal: decimalPart,
                };
            }
            // 如果沒有小數點，只輸出整數部分
            return {
                integer: numStr,
                decimal: null,
            };
        },
    },
    computed: {
        foreignToTwdAmt() {
            let amt = 0;
            if (this.cnyRat !== 0) {
                amt = this.v * this.cnyRat;
            }
            if (this.cnyRat === 0) {
                amt = this.v * this.getCnyRat(this.cny);
            }
            return Number(amt).toLocaleString('en');
        },
        formatedValue() {
            let { v } = this;

            if (this.round === true) {
                v = Math.round(v);
            }

            if (this.abs === true) {
                v = Math.abs(v);
            }

            let value = Number(v).toLocaleString('en');

            if (this.precision !== null) {
                value = Number(v).toLocaleString('en', { maximumFractionDigits: this.precision, minimumFractionDigits: this.precision });
            }

            let output = value;

            if (this.zero && value === 0) {
                output = this.zero;
                return output;
            }
            if (value === 'NaN') output = '';

            if (this.showPositivePlus === true) if (this.v > 0) output = `+${value}`;

            return this.formatNumberWithSpans(output);
        },
    },
};
</script>
<style lang="scss">
.money {
    font-weight: bold;
    display: inline-block;
    white-space: nowrap;
    word-break: keep-all;
    text-overflow: unset;

    &.foreignCny {
        // text-decoration: underline;
    }
    >.decimal {
        display: inline-block;
        zoom: 75%;
    }
}
</style>
